import {refreshState} from 'interactors/statePersistence';
import {useRefreshStore} from 'ui/adapters/Core';
import {updateWidget} from 'ui/adapters/Device';

export function useStateDependentAdapters(): (settings: CoreState) => void {
  const refreshStore = useRefreshStore();

  return function callAdapters(settings: CoreState): void {
    refreshStore(settings);
    refreshState(settings);
    updateWidget(settings);
  };
}
